module.exports = __webpack_public_path__ + "img/main-ro-1.13467c52.jpg";